var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
const getRoles = fetcher.path("/api/roles").method("get").create();
export function getAllRoles() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getRoles({});
        return data;
    });
}
export const deleteRole = fetcher.path("/api/roles/{id}").method("delete").create();
export const purgeRole = fetcher.path("/api/roles/{id}/purge").method("post").create();
export const undeleteRole = fetcher.path("/api/roles/{id}/undelete").method("post").create();
